import { css } from "@emotion/css"
import AttachMoneyIcon from "@material-ui/icons/AttachMoney"
import PersonAddIcon from "@material-ui/icons/PersonAdd"
import StayPrimaryPortraitIcon from "@material-ui/icons/StayPrimaryPortrait"
import ComputerIcon from "@material-ui/icons/Computer"
import ChatBubbleIcon from "@material-ui/icons/ChatBubbleOutline"
import InsertDriveFile from "@material-ui/icons/InsertDriveFile"
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople"
import ContactPhoneIcon from "@material-ui/icons/ContactPhone"
import HourglassFullIcon from "@material-ui/icons/HourglassFull"
import { UPDATE_USER, User } from "AdminApp"
import { useState } from "react"
import { useMutation } from "@apollo/client"
import { Group } from "@material-ui/icons"

export const UserCell: React.FC<{
  user: User
  onClick: (user: User) => void
}> = ({ user, onClick }) => {
  const lastActiveAt = new Date(user.lastActiveAt ?? 0).getTime()
  const ms = Date.now() - lastActiveAt
  const daysSinceLastActive = Math.floor(ms / (1000 * 60 * 60 * 24))
  const numContacts = user.numContacts - 2 // dont count self contact
  return (
    <div
      onClick={() => onClick(user)}
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        cursor: "pointer",
      }}
      className={css`
        background-color: white;
        &:hover {
          background-color: #f7f7f7;
        }
        padding: 0;
      `}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: 130,
          maxWidth: 130,
          minWidth: 130,
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
        }}
      >
        <p
          style={{
            margin: 5,
            textOverflow: "ellipsis",
            color: user.banned ? "lightgray" : "black",
          }}
        >
          {user.username}
        </p>
      </div>
      <div
        style={{
          opacity: user.fromInviteCode?.length === 9 ? 1 : 0,
          width: 5,
          height: 5,
          borderRadius: 100,
          backgroundColor: "grey",
        }}
      ></div>
      <div
        style={{
          backgroundColor: user.numInvites ? "#08c1ff" : "lightgray",
          borderRadius: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 20,
          paddingLeft: 6,
          paddingRight: 6,
          marginLeft: 10,
        }}
      >
        {
          <p
            style={{
              color: user.numInvites ? "black" : "#f0f0f0",
            }}
          >
            +{user.numInvites}
          </p>
        }
      </div>
      <div
        style={{
          // backgroundColor: numContacts ? "#08c1ff" : "lightgray",
          backgroundColor: "lightgray",
          borderRadius: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 20,
          paddingLeft: 6,
          paddingRight: 6,
          marginLeft: 10,
        }}
      >
        {
          <p
            style={{
              color: numContacts ? "black" : "#f0f0f0",
            }}
          >
            {numContacts}
          </p>
        }
      </div>
      <div
        style={{
          // backgroundColor: numContacts ? "#08c1ff" : "lightgray",
          backgroundColor: user.hasBeenContacted ? "#4287f5" : "lightgray",
          borderRadius: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 20,
          paddingLeft: 6,
          paddingRight: 6,
          marginLeft: 10,
        }}
      >
        <ContactPhoneIcon
          style={{
            color: "#f0f0f0",
            fontSize: 14,
          }}
        />
      </div>
      <div
        title={
          user.upgradedAt ? new Date(user.upgradedAt).toString() : undefined
        }
        style={{
          backgroundColor:
            user.type === "pro"
              ? "lightgreen"
              : user.type !== "og" && user.downgradedAt
              ? "red"
              : "lightgrey",
          borderRadius: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 20,
          height: 20,
          marginLeft: 5,
        }}
      >
        {user.type === "pro" && !user.numPaywallHits ? (
          <AttachMoneyIcon style={{ color: "black", fontSize: 14 }} />
        ) : user.numPaywallHits ? (
          <p style={{ color: "white", fontSize: 16 }}>{user.numPaywallHits}</p>
        ) : (
          <AttachMoneyIcon
            style={{ color: "white", fontSize: 16, opacity: 0.5 }}
          />
        )}
      </div>
      <div style={{ position: "relative" }}>
        <div
          style={{
            backgroundColor: user.versionMobile ? "#f7af07" : "lightgrey",
            borderRadius: 100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 20,
            height: 20,
            marginLeft: 5,
          }}
        >
          <div
            style={{
              backgroundColor:
                user.numMobilePushTokens > 0 ? "#48ff00" : "#ff2b59",
              position: "absolute",
              opacity: !user.versionMobile ? 0 : 0.7,
              zIndex: 100,
              top: -1,
              right: -1,
              width: 8,
              height: 8,
              borderRadius: 100,
            }}
          />
          <StayPrimaryPortraitIcon
            style={{
              color: "white",
              fontSize: 16,
              opacity: user.versionMobile ? 1 : 0.5,
            }}
          />
        </div>
      </div>
      <div style={{ position: "relative" }}>
        <div
          style={{
            backgroundColor:
              user.webNotificationPermission === "granted"
                ? "#48ff00"
                : user.webNotificationPermission === "denied"
                ? "#ff2b59"
                : "lightgrey",
            position: "absolute",
            opacity: !user.webNotificationPermission ? 0 : 0.7,
            zIndex: 100,
            top: -1,
            right: -1,
            width: 8,
            height: 8,
            borderRadius: 100,
          }}
        />
        <div
          style={{
            backgroundColor: user.versionWeb ? "#f79307" : "lightgrey",
            borderRadius: 100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 20,
            height: 20,
            marginLeft: 5,
          }}
        >
          {user.versionWeb ? (
            <ComputerIcon style={{ color: "white", fontSize: 14 }} />
          ) : (
            <ComputerIcon
              style={{ color: "white", fontSize: 16, opacity: 0.5 }}
            />
          )}
        </div>
      </div>
      <div style={{ position: "relative" }}>
        <div
          title={
            user.firstCommentedAt
              ? new Date(user.firstCommentedAt).toString()
              : undefined
          }
          style={{
            backgroundColor: user.firstCommentedAt ? "#f2e28a" : "lightgrey",
            borderRadius: 100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 20,
            height: 20,
            marginLeft: 5,
          }}
        >
          {user.firstCommentedAt ? (
            <ChatBubbleIcon style={{ color: "white", fontSize: 14 }} />
          ) : (
            <ChatBubbleIcon
              style={{ color: "white", fontSize: 16, opacity: 0.5 }}
            />
          )}
        </div>
      </div>
      <div style={{ position: "relative" }}>
        <div
          title={
            user.firstCreatedFileAt
              ? new Date(user.firstCreatedFileAt).toString()
              : undefined
          }
          style={{
            backgroundColor: user.firstCreatedFileAt ? "#bbf28a" : "lightgrey",
            borderRadius: 100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 20,
            height: 20,
            marginLeft: 5,
          }}
        >
          {user.firstCreatedFileAt ? (
            <InsertDriveFile style={{ color: "white", fontSize: 14 }} />
          ) : (
            <InsertDriveFile
              style={{ color: "white", fontSize: 16, opacity: 0.5 }}
            />
          )}
        </div>
      </div>
      <div style={{ position: "relative" }}>
        <div
          title={
            user.firstCreatedGroupAt
              ? new Date(user.firstCreatedGroupAt).toString()
              : undefined
          }
          style={{
            backgroundColor: user.firstCreatedGroupAt ? "#cf8af2" : "lightgrey",
            borderRadius: 100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 20,
            height: 20,
            marginLeft: 5,
          }}
        >
          {user.numInviteClicks ? (
            <p style={{ color: "#f7f7f7" }}>{user.numInviteClicks}</p>
          ) : user.firstCreatedGroupAt ? (
            <Group style={{ color: "white", fontSize: 14 }} />
          ) : (
            <Group style={{ color: "white", fontSize: 16, opacity: 0.5 }} />
          )}
        </div>
      </div>
      <div
        style={{
          backgroundColor:
            "rgba(10, 194, 255, " + (1 - daysSinceLastActive / 20) + ")",
          borderRadius: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 20,
          paddingLeft: 6,
          paddingRight: 6,
          marginLeft: 5,
          flexDirection: "row",
        }}
      >
        <HourglassFullIcon style={{ color: "white", fontSize: 12 }} />
        {
          <p
            style={{
              color: daysSinceLastActive ? "black" : "#f0f0f0",
            }}
          >
            {daysSinceLastActive}
          </p>
        }
      </div>
    </div>
  )
}
